module.exports = __webpack_public_path__ + "img/no-icon.04a14689.png";